/**
 * here put all the actions from api, using the types
 */
import {
  GET_CATEGORY_DATA_INIT,
  GET_CATEGORY_DATA_SUCCESS,
  GET_CATEGORY_DATA_FAILURE,
  GET_FILTERED_DATA_INIT,
  GET_FILTERED_SUCCESS,
  GET_FILTERED_FAILURE,
  UPDATE_LOADING,
} from './types';
import API from '../lib/api';
import CategoryFormat from '../helpers/CategoryFormat';

/**
 * Action creators
 * update loading state
 */
export const updateLoadingState = state => ({ type: UPDATE_LOADING, payload: state });

/**
 * Fetch incidents filtered
 */
export const getFilteredDataInit = () => ({ type: GET_FILTERED_DATA_INIT });

export const getFilteredDataSuccess = data => ({
  type: GET_FILTERED_SUCCESS,
  payload: data,
});

export const getFilteredDataFailure = error => ({
  type: GET_FILTERED_FAILURE,
  payload: error,
});

/**
 * Fetch category
 */
export const getCategoryDataInit = () => ({ type: GET_CATEGORY_DATA_INIT });

export const getCategoryDataSuccess = data => ({
  type: GET_CATEGORY_DATA_SUCCESS,
  payload: data,
});

export const getCategoryDataFailure = error => ({
  type: GET_CATEGORY_DATA_FAILURE,
  payload: error,
});

/**
 * Action creators ASYNC
 * Action handling async fetch to the API of the filtered data
 */
export const getFilteredData = filters => async (dispatch) => {
  // ----- Initial call, fetching the data
  dispatch(getFilteredDataInit());
  try {
    const data = await API.map.getFilteredData(filters);
    const dataGroup = [data[0], data[0].features.length, data[1]];
    return dispatch(getFilteredDataSuccess(dataGroup));
  } catch (error) {
    return dispatch(getFilteredDataFailure([error, null, 0, API.map.getFinalParams(filters)]));
  }
};

/**
 * Action handling async fetch to the API of the categories
 */
export const getCategoryData = category => async (dispatch) => {
  // ----- Initial call, fetching the data
  dispatch(getCategoryDataInit());
  try {
    const data = await API.map.getCategoryData(category);
    const incomingCategory = {};
    incomingCategory[category] = CategoryFormat(data, category);
    return dispatch(getCategoryDataSuccess(incomingCategory));
  } catch (error) {
    return dispatch(getCategoryDataFailure(error));
  }
};
